
import { ENV } from '../../config/runtimeEnv';
import { getSessionUser } from "../../utils/auth/sessionUser";

//Types
import { ReportTemplate } from "../../types/healthcare/ReportTypes";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;

export const fetchReportTemplates = async (): Promise<{
	data: ReportTemplate[];
}> => {
	const response = await http.get(
		`${API_BASE_URL}/practitioner/reports`
	);

	return {
		data: response.data,
	};
};

export const fetchSingleReportTemplateById = async (
	id: number
): Promise<{
	data: ReportTemplate;
}> => {
	const response = await http.get(`${API_BASE_URL}/practitioner/reports/single/${id}`);
	return {
		data: response.data,
	};
};

export const setNewReportTemplate = async (reportData: Partial<ReportTemplate>): Promise<{
	data: ReportTemplate;
	message: string;
}> => {
	const user = getSessionUser();
	const response = await http.post(`${API_BASE_URL}/practitioner/reports`, {
		reportData,
		user_id: user.uuid,
	});
	return {
		data: response.data.data,
		message: response.data.message,
	};
};

export const updateReportTemplate = async (reportData: Partial<ReportTemplate>): Promise<{
	data: ReportTemplate;
	message: string;
}> => {
	const user = getSessionUser();
	const response = await http.put(`${API_BASE_URL}/practitioner/reports/${reportData.id}`, {
		reportData,
		user_id: user.uuid,
	});
	return {
		data: response.data.data,
		message: response.data.message,
	};
};

export const deleteReportTemplate = async (reportId: number) => {
	const response = await http.delete(`${API_BASE_URL}/practitioner/reports/${reportId}`);
	return response.data;
};
